import { render, staticRenderFns } from "./SocialItem.vue?vue&type=template&id=34be6ad2&scoped=true"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"
import style0 from "./SocialItem.vue?vue&type=style&index=0&id=34be6ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be6ad2",
  null
  
)

export default component.exports